module.exports = __webpack_public_path__ + "static/i-robot-3b3777fad6ed5bc44e6836015cab3b26.jpg";